import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { formatDate, formatMoeda, getPseudoID, handleNumberOnly, strToFloat } from "../../../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { infPagInterface, InfPrazoInterface } from "../../../interfaces";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";
import { format } from "date-fns";

const initialForm: InfPrazoInterface = {
    id: 0,
    dVenc: format(new Date(), 'yyyy-MM-dd'),
    nParcela: '',
    vParcela: 0

}
interface formProps {
    form: infPagInterface;
    setForm: React.Dispatch<React.SetStateAction<infPagInterface>>
}

const PrazoPagto: React.FC<formProps> = ({ form, setForm }) => {
    const [formPrazo, setFormPrazo] = useState<InfPrazoInterface>(initialForm);
    const [showAlert, setShowAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');
    const [selected, setSelected] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [saldo, setSaldo] = useState(form.vContrato);
    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(0);
    }

    const handleOpenModal = (id: number) => {
        setSelected(id);
        setShowModal(true);
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setFormPrazo((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleChangeNumeric = (e: any) => {
        const { name, value } = e.target;

        setFormPrazo((prev) => ({
            ...prev,
            [name]: strToFloat(value)
        }))
    }

    const validarPreenchimento = () => {

        if (formPrazo.vParcela === 0) {
            alerta('Informe o valor da parcela');
            return false;
        }

        if (formPrazo.nParcela === "") {
            alerta('Informe o numero da parcela.');
            return false;
        }

        if (formPrazo.dVenc === "") {
            alerta('Informe a data de vencimento.');
            return false;
        }

        if (form.indPag === 0) {
            alerta('Somente pode adicionar em caso de Ind. Forma Pagto for a prazo.');
            return false;
        }

        if (form.vContrato === 0) {
            alerta('Informe o valor do contrato.');
            return false;
        }


        return true;
    }

    const handleAddPrazo = () => {
        if (validarPreenchimento()) {
            setForm({
                ...form,
                infPrazo: [...(form.infPrazo || []), {
                    id: getPseudoID(),
                    dVenc: formPrazo.dVenc,
                    nParcela: formPrazo.nParcela,
                    vParcela: formPrazo.vParcela
                }]
            });
            setFormPrazo(initialForm);
        }
    }

    const handleRemovePrazo = (id: number) => {
        setForm({
            ...form,
            infPrazo: form.infPrazo?.filter((item: InfPrazoInterface) => item.id !== id)
        })
        setShowModal(false);
        setSelected(0);
    }

    useEffect(() => {
        const total = form.infPrazo?.map((item: InfPrazoInterface) =>
            item.vParcela).reduce((total, num) => total + parseFloat(num.toFixed(2)), 0) || 0;
        setSaldo(form.vContrato - total);

    }, [form.vContrato, form.infPrazo])

    return (<>
        <Row className="mb-3 g-2">
            <Col md>
                <Form.Group>
                    <Form.Label>Num. Parcela</Form.Label>
                    <Form.Control name="nParcela" value={formPrazo.nParcela} maxLength={3} onKeyUp={handleNumberOnly}
                        onChange={handleChange} />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group>
                    <Form.Label>Data Vencto</Form.Label>
                    <Form.Control name="dVenc" value={formPrazo.dVenc} type="date" onChange={handleChange} />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group>
                    <Form.Label>Vlr. Parcela</Form.Label>
                    <Form.Control name="vParcela" value={formPrazo.vParcela} type="number" maxLength={16}
                        onChange={handleChangeNumeric}
                    />
                </Form.Group>
            </Col>
        </Row>
        <Row className="mb-3 g-2">
            <Col md={'auto'} className="d-flex align-items-end">
                <Button title="Adicionar Prazo" onClick={handleAddPrazo}>
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </Button>
            </Col>
            <Col md={'auto'} className="d-flex align-items-center mb-0">
                <Form.Label className="mb-0">Saldo Vlr Contrato</Form.Label>
            </Col>
            <Col md='4'>
                <Form.Control value={formatMoeda(saldo)} disabled
                />
            </Col>

        </Row>
        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                    <th>Num. parcela</th>
                    <th>Data Vencto</th>
                    <th>Vlr. Parcela</th>
                </tr>
            </thead>
            <tbody>
                {form.infPrazo?.map((item: InfPrazoInterface) => (
                    <tr key={item.id}>
                        <td className="text-center">
                            <a href="javasctipt:void(0)" className="text-danger"
                                onClick={() => handleOpenModal(item.id)}>
                                <FontAwesomeIcon icon={faTrash} />
                            </a>
                        </td>
                        <td>{item.nParcela}</td>
                        <td>{formatDate(item.dVenc)}</td>
                        <td>{formatMoeda(item.vParcela)}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemovePrazo}
            selectedObject={''}
            id={selected}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}
export default PrazoPagto;